const DEBIT_CARDS_IN_OTHERS_CITY = [
  "https://halvacard.ru/order/debet-cards/city-volgograd/",
  "https://halvacard.ru/order/debet-cards/city-voronezh/",
  "https://halvacard.ru/order/debet-cards/city-ekaterinburg/",
  "https://halvacard.ru/order/debet-cards/city-irkutsk/",
  "https://halvacard.ru/order/debet-cards/city-krasnodar/",
  "https://halvacard.ru/order/debet-cards/city-krasnoyarsk/",
  "https://halvacard.ru/order/debet-cards/city-novosibirsk/",
  "https://halvacard.ru/order/debet-cards/city-omsk/",
  "https://halvacard.ru/order/debet-cards/city-orenburg/",
  "https://halvacard.ru/order/debet-cards/city-perm/",
  "https://halvacard.ru/order/debet-cards/city-rostov-na-donu/",
  "https://halvacard.ru/order/debet-cards/city-ryazan/",
  "https://halvacard.ru/order/debet-cards/city-samara/",
  "https://halvacard.ru/order/debet-cards/city-sankt-peterburg/",
  "https://halvacard.ru/order/debet-cards/city-saratov/",
  "https://halvacard.ru/order/debet-cards/city-tyumen/",
  "https://halvacard.ru/order/debet-cards/city-ufa/",
  "https://halvacard.ru/order/debet-cards/city-chelyabinsk/",
  "https://halvacard.ru/order/debet-cards/city-yaroslavl/",
  "https://halvacard.ru/order/debet-cards/city-nizhnij-novgorod/",
]

const DEBIT_CARDS_BY_METHOD_OF_RECEIPT = [
  "https://halvacard.ru/order/debet-cards/bez-pasporta/",
  "https://halvacard.ru/order/debet-cards/bez-poseshcheniya-banka/",
  "https://halvacard.ru/order/debet-cards/onlajn-zayavka/",
  "https://halvacard.ru/order/debet-cards/s-dostavkoj-na-dom/",
  "https://halvacard.ru/order/debet-cards/s-dostavkoj-po-pochte/",
  "https://halvacard.ru/order/debet-cards/srochnaya/",
]

const DEBIT_CARDS_ONLINE = [
  "https://halvacard.ru/order/debet-cards/virtualnaya/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-bez-pasporta/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-besplatnaya/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-na-ps-mir/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-dlya-oplaty-podpisok/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-dlya-pokupok/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-dlya-rebenka/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-momentalnaya/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-neimennaya/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-s-kehshbehkom/",
  "https://halvacard.ru/order/debet-cards/virtualnaya-bez-poseshcheniya-banka/",
]

const DEBIT_CARDS_BY_TYPE = [
  "https://halvacard.ru/order/debet-cards/dlya-biznesa/",
  "https://halvacard.ru/order/debet-cards/dlya-ip/",
  "https://halvacard.ru/order/debet-cards/dlya-samozanyatyh/",
  "https://halvacard.ru/order/debet-cards/v-dollarah/",
  "https://halvacard.ru/order/debet-cards/v-evro/",
  "https://halvacard.ru/order/debet-cards/valyutnaya/",
  "https://halvacard.ru/order/debet-cards/dlya-nerezidentov/",
  "https://halvacard.ru/order/debet-cards/dlya-pensionerov/",
  "https://halvacard.ru/order/debet-cards/dlya-podrostka/",
  "https://halvacard.ru/order/debet-cards/dlya-studentov/",
  "https://halvacard.ru/order/debet-cards/kobrendingovye/",
  "https://halvacard.ru/order/debet-cards/molodezhnaya/",
  "https://halvacard.ru/order/debet-cards/momentalnaya/",
  "https://halvacard.ru/order/debet-cards/multivalyutnaya/",
  "https://halvacard.ru/order/debet-cards/neimennaya/",
  "https://halvacard.ru/order/debet-cards/s-beskontaktnoj-oplatoj/",
  "https://halvacard.ru/order/debet-cards/s-vremennoj-registraciej/",
  "https://halvacard.ru/order/debet-cards/detskaya/",
  "https://halvacard.ru/order/debet-cards/momentalnaya-bez-vizita-v-bank/",
]

const DEBIT_CARDS_WITH_SPECIAL_CONDITIONS = [
  "https://halvacard.ru/order/debet-cards/samaya-vygodnaya/",
  "https://halvacard.ru/order/debet-cards/dlya-pokupok-v-internete/",
  "https://halvacard.ru/order/debet-cards/dlya-puteshestvij-po-rf/",
  "https://halvacard.ru/order/debet-cards/socialnaya/",
  "https://halvacard.ru/order/debet-cards/zolotaya/",
  "https://halvacard.ru/order/debet-cards/nakopitelnaya/",
  "https://halvacard.ru/order/debet-cards/platinum/",
  "https://halvacard.ru/order/debet-cards/premialnaya/",
  "https://halvacard.ru/order/debet-cards/prioriti-pass/",
  "https://halvacard.ru/order/debet-cards/s-besplatnym-obsluzhivaniem/",
  "https://halvacard.ru/order/debet-cards/s-bolshim-limitom-snyatiya-nalichnyh/",
  "https://halvacard.ru/order/debet-cards/s-bonusami/",
  "https://halvacard.ru/order/debet-cards/cashback/",
  "https://halvacard.ru/order/debet-cards/s-kehshbehkom-za-zhkkh/",
  "https://halvacard.ru/order/debet-cards/cashback-na-azs/",
  "https://halvacard.ru/order/debet-cards/s-kehshbehkom-na-produkty/",
  "https://halvacard.ru/order/debet-cards/s-milyami/",
  "https://halvacard.ru/order/debet-cards/s-unikalnym-dizajnom/",
  "https://halvacard.ru/order/debet-cards/so-snyatiem-nalichnyh-i-perevodami-bez-komissii/",
]

const DEBIT_CARDS_BY_PAYMENT_SYSTEM = [
  "https://halvacard.ru/order/debet-cards/viza/",
  "https://halvacard.ru/order/debet-cards/viza-zolotaya/",
  "https://halvacard.ru/order/debet-cards/viza-klassik/",
  "https://halvacard.ru/order/debet-cards/viza-platinum/",
  "https://halvacard.ru/order/debet-cards/masterkard/",
  "https://halvacard.ru/order/debet-cards/masterkard-virtualnaya/",
  "https://halvacard.ru/order/debet-cards/mir-dlya-podrostkov/",
  "https://halvacard.ru/order/debet-cards/mir-s-besplatnym-obsluzhivaniem/",
]

const map = new Map<string[], (url: string) => unknown>([
  [
    DEBIT_CARDS_BY_METHOD_OF_RECEIPT,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Чем карта Халва удобнее обычной дебетовой?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "Закажите карту онлайн с бесплатной доставкой или оформите виртуальную — всё быстро и без визита в банк.",
          upvoteCount: 35,
        },
      },
    }),
  ],
  [
    DEBIT_CARDS_ONLINE,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему карта Халва лучше виртуальной дебетовой карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "📱 Оформление виртуальной карты Халва за пару минут, 💰 кэшбэк до 10%, ⏳ рассрочка на покупки без переплат.",
          upvoteCount: 40,
        },
      },
    }),
  ],
  [
    DEBIT_CARDS_BY_TYPE,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "В чём отличие дебетовой карты Халва от обычной дебетовой карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "Халва — карта с рассрочкой до 10 месяцев, лимитом до 500 000 ₽ и высоким кешбэком за покупки.",
          upvoteCount: 45,
        },
      },
    }),
  ],
  [
    DEBIT_CARDS_WITH_SPECIAL_CONDITIONS,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему карта «Халва» лучше дебетовой карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "🆓 Бесплатный выпуск и обслуживание, 💰 кэшбэк и бонусы за покупки, ⏳ рассрочка без процентов.",
          upvoteCount: 50,
        },
      },
    }),
  ],
  [
    DEBIT_CARDS_BY_PAYMENT_SYSTEM,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему Халва лучше дебетовой карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "💸 До +3% к ставке вклада\n💰 кешбэк до 10%\n💳 бесплатный выпуск и обслуживание",
          upvoteCount: 36,
        },
      },
    }),
  ],
  [
    DEBIT_CARDS_IN_OTHERS_CITY,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему карта Халва выгоднее обычной дебетовой карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "🚘 Бесплатная доставка карты Халва курьером. 💰 Кэшбэк до 10%. 💸 Рассрочка без процентов.",
          upvoteCount: 30,
        },
      },
    }),
  ],
])

export const typeQAPageDebitCard = (url: string) => {
  const iterator = map.entries()

  let data = iterator.next()

  while (data.value) {
    const [urls, fn] = data.value

    if (urls.includes(url)) {
      return JSON.stringify(fn(url))
    }

    data = iterator.next()
  }

  // Дефолтный вариант
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "QAPage",
    mainEntity: {
      "@type": "Question",
      name: "Почему Халва лучше дебетовой карты?",
      url,
      answerCount: 1,
      acceptedAnswer: {
        "@type": "Answer",
        text: "💸 До +3% к ставке вклада\n💰 кешбэк до 10%\n💳 бесплатный выпуск и обслуживание",
        upvoteCount: 36,
      },
    },
  })
}
